/**
 * Constants for NCR Edit module
 */

import { StepConfig } from './types';

export const WORKFLOW_STEPS: StepConfig[] = [
  { num: 1, label: 'Created', sublabel: 'NCR raised', role: 'Customer' },
  { num: 2, label: 'CA Submitted', sublabel: 'Root cause analysis', role: 'Supplier' },
  { num: 3, label: 'CAR Submitted', sublabel: 'Corrective action', role: 'Supplier' },
  { num: 4, label: 'Closed', sublabel: 'Complete', role: 'Customer' },
];

// CR-7069: Only why_1 is mandatory. Why 2 onwards are optional — the supplier
// may stop at any depth when the root cause is found (e.g., stop at WHY 3).
// CR-7139: why_1 is the first Why of the `whys` list (see whyChain.ts).
// CR-7353: the required fields are the OCCURRENCE chain; the Escape chain is
// optional (pending a DE decision on mandatoriness).
export const RCA_REQUIRED_FIELDS = [
  'why_1',
  'selected_root_cause',
  'immediate_corrective_action',
];

// CR-5999: User-friendly labels for the RCA required fields so validation
// messaging surfaces what the user actually sees on screen ("Why 1?",
// "Immediate Containment Action") instead of raw API field names
// ("why_1", "immediate_corrective_action").
export const RCA_FIELD_LABELS: Record<string, string> = {
  immediate_corrective_action: 'Immediate Containment Action',
  why_1: 'Why 1?',
  why_2: 'Why 2?',
  why_3: 'Why 3?',
  why_4: 'Why 4?',
  why_5: 'Why 5?',
  selected_root_cause: 'Selected Root Cause',
  // CR-7353: Escape root-cause chain (optional today).
  escape_why_1: 'Escape Why 1?',
  escape_why_2: 'Escape Why 2?',
  escape_why_3: 'Escape Why 3?',
  escape_why_4: 'Escape Why 4?',
  escape_why_5: 'Escape Why 5?',
  escape_selected_root_cause: 'Escape Selected Root Cause',
};

// CR-7354: the Occurrence pair stays required on submit (as the single pair
// was); the Escape pair is optional (pending a DE decision on mandatoriness).
export const CAR_REQUIRED_FIELDS = ['corrective_action', 'preventive_action', 'impact_assessment'];

// CR-6000: User-friendly labels for the required CAR fields so the Submit CAR
// validation surfaces what the user sees on screen ("Corrective Action") rather
// than raw API field names ("corrective_action"). Mirrors RCA_FIELD_LABELS.
// CR-7353: kept generic (not "Occurrence …") so the message reads correctly
// whether or not the Escape split is on — the on-screen field label carries the
// "Occurrence" wording when it is, exactly as the RCA labels stay generic while
// the section heading names the chain.
export const CAR_FIELD_LABELS: Record<string, string> = {
  corrective_action: 'Corrective Action',
  preventive_action: 'Preventive Action',
  escape_corrective_action: 'Escape Corrective Action',
  escape_preventive_action: 'Escape Preventive Action',
  impact_assessment: 'Impact Assessment',
};
